module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/25b09596a1a720b806ba472ae718480c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_success.svg
// module id = 0WBn
// module chunks = 1